import { createAction, props } from '@ngrx/store';

export enum ArticlesActions {
  ArticlesRequested = '[Articles] Articles Requested',
  ArticlesLoaded = '[Articles] Articles Loaded',
  ArticlesError = '[Articles] Articles Error',
  AllArticlesRequested = '[Articles] All Articles Requested',
  AllArticlesLoaded = '[Articles] All Articles Loaded',
  AllArticlesError = '[Articles] All Articles Error',
  ArticlesForGestiuneRequested = '[Articles] Articles For Gestiune Requested',
  ArticlesForGestiuneLoading = '[Articles] Articles For Gestiune Loading',
  ArticlesForGestiuneLoaded = '[Articles] Articles For Gestiune Loaded',
  ArticlesForGestiuneError = '[Articles] Articles For Gestiune Error',
  ArticlesForGestiuneNextPage = '[Articles] Articles For Gestiune Next Page',
  ArticlesForGestiuneReset = '[Articles] Articles For Gestiune Reset',
  ArticlesForGestiuneSearch = '[Articles] Articles For Gestiune Search',
  ArticlesForGestiuneAppendInitialItems = '[Articles] Articles For Gestiune Append Initial Items',

  ArticlesPaginatedRequested = '[Articles] Articles Paginated Requested',
  ArticlesPaginatedLoading = '[Articles] Articles Paginated Loading',
  ArticlesPaginatedLoaded = '[Articles] Articles Paginated Loaded',
  ArticlesPaginatedError = '[Articles] Articles Paginated Error',
  ArticlesPaginatedNextPage = '[Articles] Articles Paginated Next Page',
  ArticlesPaginatedReset = '[Articles] Articles Paginated Reset',
  ArticlesPaginatedSearch = '[Articles] Articles Paginated Search',
  ArticlesPaginatedAppendInitialItems = '[Articles] Articles Paginated Append Initial Items',
  
  ArticlesForGestiuneConsumabileRequested = '[Articles] Articles For Gestiune Consumabile Requested',
  ArticlesForGestiuneConsumabileLoading   = '[Articles] Articles For Gestiune Consumabile Loading',
  ArticlesForGestiuneConsumabileLoaded    = '[Articles] Articles For Gestiune Consumabile Loaded',
  ArticlesForGestiuneConsumabileError     = '[Articles] Articles For Gestiune Consumabile Error',
  ArticlesForGestiuneConsumabileNextPage  = '[Articles] Articles For Gestiune Consumabile Next Page',
  ArticlesForGestiuneConsumabileReset     = '[Articles] Articles For Gestiune Consumabile Reset',
  ArticlesForGestiuneConsumabileSearch    = '[Articles] Articles For Gestiune Consumabile Search',
  ArticlesForGestiuneConsumabileAppendInitialItems = '[Articles] Articles For Gestiune Consumabile Append Initial Items',
  ArticlesWithGestiuneRequested = '[Articles] Articles With Gestiune Requested',
  ArticlesWithGestiuneLoading = '[Articles] Articles With Gestiune Loading',
  ArticlesWithGestiuneLoaded = '[Articles] Articles With Gestiune Loaded',
  ArticlesWithGestiuneError = '[Articles] Articles With Gestiune Error',
  ArticlesWithGestiuneNextPage = '[Articles] Articles With Gestiune Next Page',
  ArticlesWithGestiuneReset = '[Articles] Articles With Gestiune Reset',
  ArticlesWithGestiuneSearch = '[Articles] Articles With Gestiune Search',
  ArticlesWithGestiuneAppendInitialItems = '[Articles] Articles With Gestiune Append Initial Items',
  ArticlesWithGestiuneOnlySecondHand = '[Articles] Articles With Gestiune Only Second Hand',
}

export const AllArticlesRequested = createAction(ArticlesActions.AllArticlesRequested);
export const AllArticlesLoaded = createAction(ArticlesActions.AllArticlesLoaded, props<{ articles: any[] }>());
export const AllArticlesError = createAction(ArticlesActions.AllArticlesError);

export const ArticlesRequested = createAction(ArticlesActions.ArticlesRequested);
export const ArticlesLoaded = createAction(ArticlesActions.ArticlesLoaded,props<{ articles: any[] }>());
export const ArticlesError = createAction(ArticlesActions.ArticlesError);

export const ArticlesForGestiuneRequested = createAction(ArticlesActions.ArticlesForGestiuneRequested, props<{gestiuneId: string | number }>());
export const ArticlesForGestiuneLoading = createAction(ArticlesActions.ArticlesForGestiuneLoading);
export const ArticlesForGestiuneLoaded = createAction(ArticlesActions.ArticlesForGestiuneLoaded, props<{ articlesForGestiune: any[] }>());
export const ArticlesForGestiuneError = createAction(ArticlesActions.ArticlesForGestiuneError);
export const ArticlesForGestiuneNextPage = createAction(ArticlesActions.ArticlesForGestiuneNextPage, props<{ gestiuneId: string | number }>());
export const ArticlesForGestiuneReset = createAction(ArticlesActions.ArticlesForGestiuneReset);
export const ArticlesForGestiuneSearch = createAction(ArticlesActions.ArticlesForGestiuneSearch, props<{ gestiuneId: string | number, search: string }>());
export const ArticlesForGestiuneAppendInitialItems = createAction(ArticlesActions.ArticlesForGestiuneAppendInitialItems, props<{ articlesForGestiune: any[] }>());

export const ArticlesPaginatedRequested = createAction(ArticlesActions.ArticlesPaginatedRequested);
export const ArticlesPaginatedLoading = createAction(ArticlesActions.ArticlesPaginatedLoading);
export const ArticlesPaginatedLoaded = createAction(ArticlesActions.ArticlesPaginatedLoaded, props<{ articlesPaginated: any[] }>());
export const ArticlesPaginatedError = createAction(ArticlesActions.ArticlesPaginatedError);
export const ArticlesPaginatedNextPage = createAction(ArticlesActions.ArticlesPaginatedNextPage);
export const ArticlesPaginatedReset = createAction(ArticlesActions.ArticlesPaginatedReset);
export const ArticlesPaginatedSearch = createAction(ArticlesActions.ArticlesPaginatedSearch, props<{ search: string }>());
export const ArticlesPaginatedAppendInitialItems = createAction(ArticlesActions.ArticlesPaginatedAppendInitialItems, props<{ articlesPaginated: any[] }>());

export const ArticlesForGestiuneConsumabileRequested = createAction(
  ArticlesActions.ArticlesForGestiuneConsumabileRequested,
  props<{ gestiuneId: string | number }>()
);
export const ArticlesForGestiuneConsumabileLoading = createAction(
  ArticlesActions.ArticlesForGestiuneConsumabileLoading
);
export const ArticlesForGestiuneConsumabileLoaded = createAction(
  ArticlesActions.ArticlesForGestiuneConsumabileLoaded,
  props<{ articlesForGestiune: any[] }>()
);
export const ArticlesForGestiuneConsumabileError = createAction(
  ArticlesActions.ArticlesForGestiuneConsumabileError
);
export const ArticlesForGestiuneConsumabileNextPage = createAction(
  ArticlesActions.ArticlesForGestiuneConsumabileNextPage,
  props<{ gestiuneId: string | number }>()
);
export const ArticlesForGestiuneConsumabileReset = createAction(
  ArticlesActions.ArticlesForGestiuneConsumabileReset
);
export const ArticlesForGestiuneConsumabileSearch = createAction(
  ArticlesActions.ArticlesForGestiuneConsumabileSearch,
  props<{ gestiuneId: string | number; search: string }>()
);
export const ArticlesForGestiuneConsumabileAppendInitialItems = createAction(
  ArticlesActions.ArticlesForGestiuneConsumabileAppendInitialItems,
  props<{ articlesForGestiune: any[] }>()
);
export const ArticlesWithGestiuneRequested = createAction(ArticlesActions.ArticlesWithGestiuneRequested);
export const ArticlesWithGestiuneLoading = createAction(ArticlesActions.ArticlesWithGestiuneLoading);
export const ArticlesWithGestiuneLoaded = createAction(ArticlesActions.ArticlesWithGestiuneLoaded, props<{ articlesWithGestiune: [] }>());
export const ArticlesWithGestiuneError = createAction(ArticlesActions.ArticlesWithGestiuneError);
export const ArticlesWithGestiuneNextPage = createAction(ArticlesActions.ArticlesWithGestiuneNextPage);
export const ArticlesWithGestiuneReset = createAction(ArticlesActions.ArticlesWithGestiuneReset);
export const ArticlesWithGestiuneSearch = createAction(ArticlesActions.ArticlesWithGestiuneSearch, props<{ search: string }>());
export const ArticlesWithGestiuneAppendInitialItems = createAction(ArticlesActions.ArticlesWithGestiuneAppendInitialItems, props<{ articlesWithGestiune: any[] }>());
export const ArticlesWithGestiuneOnlySecondHand = createAction(ArticlesActions.ArticlesWithGestiuneOnlySecondHand, props<{ onlySecondHand: false }>());
